import { makeIsAllowed } from '@kanda-libs/ks-component-ts';

import { YOUR_INFO_CLASS_NAMES } from '../../constants';

export const CLASS_NAMES = {
  title: 'text-14-22-em text-neutral-800',
  container: 'flex flex-col',
  header: 'flex flex-row justify-between mb-2',
};

export const PROPS = {
  title: {
    text: 'Employment',
    className: YOUR_INFO_CLASS_NAMES.title,
  },
  employmentStatus: {
    placeholder: 'Your secondary employment status',
  },
  grossAnnualIncome: {
    type: 'price',
    icon: 'pound',
    iconVariant: 'dark',
    symbol: '',
    label: 'Gross Annual Income',
    placeholder: 'Your gross annual income/salary',
    validation: {
      min: { value: 100, message: 'Amount must be great than £1' },
      required: {
        value: true,
        message: 'You must provide your gross annual salary',
      },
    },
  },
  additionalEmployment: {
    name: 'applicant_details.additional_employment_details',
  },
  years: {
    label: '',
    placeholder: 'Years',
    isAllowed: makeIsAllowed(0, 100),
  },
  months: {
    label: '',
    placeholder: 'Months',
    isAllowed: makeIsAllowed(0, 11),
  },
};

export const ERROR_PROPS = {
  className: 'text-style-h text-red-200 -mt-4 mb-6',
};
